import en from "./en/messages";
import es from "./es/messages";

export const catalogs: { [key: string]: any } = {
  en,
  es,
};
